<template>
    <section class="py-8 bg-whitelg:py-16">
      <div class="relative max-w-5xl px-4 mx-auto">
        <!-- Title -->
        <div class="text-xl text-center text-black sm:text-2xl xl:text-28 font-ww-bold" v-html="title"></div>
  
        <!-- Content Grid -->
        <div class="grid items-center grid-cols-12 mt-14 lg:gap-x-10 xl:min-h-[500px]">
          <!-- Questions Section -->
          <div class="order-2 col-span-12 lg:col-span-6 lg:order-1">
            <div
              v-for="(faq, index) in faqs"
              :key="index"
              class="text-center text-black md:mt-10 sm:text-lg xl:text-xl lg:text-left"
            >
              <div class="font-ww-bold">{{ faq.question }}</div>
              <div class="mt-4 font-ww-light">{{ faq.answer }}</div>
            </div>
          </div>
  
          <!-- Image Section -->
          <div class="order-1 col-span-12 lg:col-span-6 lg:order-2">
            <nuxt-img
              :src="imageSrc"
              :alt="imageAlt"
              sizes="xs:281px sm:391px md:576px lg:1024px xl:576px 2xl:576px"
              loading="lazy"
              format="webp"
              width="576"
              height="597"
              class="mx-auto xl:absolute xl:top-24"
            />
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  // Props for dynamic content
  const props = defineProps({
    title: {
      type: String,
      default: 'Common Questions About Your Protection Plan:',
    },
    faqs: {
      type: Array,
      default: () => [
        {
          question: 'Q: How does the digital punch card work?',
          answer:
            "A: It's simple and automatic! With every subscription order, you'll earn a 'punch' on your digital card. On your 8th order, you'll automatically receive your bag free.",
        },
        {
          question: 'Q: Can I change my coffee selection?',
          answer:
            'A: Yes! You can easily switch between any of our roasts while maintaining your price protection and rewards progress.',
        },
        {
          question: 'Q: What if I need to change my delivery schedule?',
          answer:
            'A: No problem! You can adjust your delivery frequency or pause shipments anytime through your account.',
        },
      ],
    },
    imageSrc: {
      type: String,
      default: '/assets/images/coffee-right-12.png',
    },
    imageAlt: {
      type: String,
      default: 'Coffee Image',
    },
  });
  
  // Builder.io configuration
  defineBuilderComponent({
    friendlyName: 'FAQWithImage',
    inputs: [
      {
        name: 'title',
        type: 'richText',
        friendlyName: 'Section Title',
        defaultValue: 'Common Questions About Your Protection Plan:',
      },
      {
        name: 'faqs',
        type: 'list',
        friendlyName: 'FAQs List',
        subFields: [
          {
            name: 'question',
            type: 'text',
            friendlyName: 'FAQ Question',
          },
          {
            name: 'answer',
            type: 'text',
            friendlyName: 'FAQ Answer',
          },
        ],
        defaultValue: [
          {
            question: 'Q: How does the digital punch card work?',
            answer:
              "A: It's simple and automatic! With every subscription order, you'll earn a 'punch' on your digital card. On your 8th order, you'll automatically receive your bag free.",
          },
          {
            question: 'Q: Can I change my coffee selection?',
            answer:
              'A: Yes! You can easily switch between any of our roasts while maintaining your price protection and rewards progress.',
          },
          {
            question: 'Q: What if I need to change my delivery schedule?',
            answer:
              'A: No problem! You can adjust your delivery frequency or pause shipments anytime through your account.',
          },
        ],
      },
      {
        name: 'imageSrc',
        type: 'file',
        friendlyName: 'Right Image Source',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        defaultValue: '/assets/images/coffee-right-12.png',
      },
      {
        name: 'imageAlt',
        type: 'text',
        friendlyName: 'Right Image Alt Text',
        defaultValue: 'Coffee Image',
      },
    ],
  });
  </script>
  